<template>
  <div class="col-lg-4 col-md-4 col-sm-6 portfolio-item">
      <div class="card h-100">
        <router-link :to="`/product/${product._id}`" class="img-wrap" :style="computedStyle">
        </router-link>
        <div class="card-body">
          <h4 class="card-title">
            <router-link :to="`/product/${product._id}`">{{ product.name }}</router-link>
          </h4>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'product',
  props: {
    product: Object,
  },
  computed: {
    computedStyle() {
      if (this.product.image) {
        return {
          'background-image': `url('/${this.product.image.path.slice(5)}')`,
        };
      }
      return null;
    },
  },
};
</script>

<style scoped>
  .img-wrap {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin: 20px 0 0;
    min-height: 240px;
    max-height: 240px;
    box-sizing: content-box;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform ease-in 0.3s;
  }
  .img-wrap:hover {
    transform: scale(1.05);
  }
  .list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
  }
  .card-title {
    font-size: 1.2rem;
    text-align: center;
  }
</style>
